import { Nullable } from 'utils/types';

export enum ACCOUNT_ROLE {
  ADVISER = 'ADVISER',
  ADVISER_SUPPORT = 'ADVISER_SUPPORT',
}

export enum FIELD {
  FIRST_NAME = 'firstName',
  SURNAME = 'surname',
  EMAIL = 'email',
  CONTACT_NUMBER = 'contactNumber',
  ROLE = 'role',
  HOW_DID_USER_HEAR_ABOUT_LIVEMORE = 'howDidUserHearAboutLivemore',
  OPTIONAL_DETAILS = 'optionalDetails',
}

export type AccountRoleType = ACCOUNT_ROLE.ADVISER | ACCOUNT_ROLE.ADVISER_SUPPORT;

export type Form = {
  [FIELD.FIRST_NAME]: Nullable<string>;
  [FIELD.SURNAME]: Nullable<string>;
  [FIELD.EMAIL]: Nullable<string>;
  [FIELD.CONTACT_NUMBER]: Nullable<string>;
  [FIELD.ROLE]: AccountRoleType | null;
  [FIELD.HOW_DID_USER_HEAR_ABOUT_LIVEMORE]: Nullable<string>;
  [FIELD.OPTIONAL_DETAILS]: Nullable<string>;
};

export enum USER_SOURCE_VALUE {
  GOOGLE_SEARCH = 'googleSearch',
  WORD_OF_MOUTH = 'wordOfMouth',
  SOCIAL_MEDIA = 'socialMedia',
  PR = 'pr',
  COMMS_FROM_LIVEMORE = 'commsFromLivemore',
  COMMS_FROM_MY_NETWORK_PR = 'commsFromMyNetworkPr',
  SOURCING_SYSTEM_ADS = 'sourcingSystemAds',
  WEBINAR = 'webinar',
  ROADSHOW_EVENT = 'roadshowEvent',
  BUSINESS_DEVELOPMENT_CALL = 'businessDevelopmentCall',
  NETWORK_LAUNCH = 'networkLaunch',
  OTHER = 'other',
}

export enum USER_SOURCE_LABEL {
  GOOGLE_SEARCH = 'Google Search',
  WORD_OF_MOUTH = 'Word of Mouth',
  SOCIAL_MEDIA = 'Social Media',
  PR = 'PR',
  COMMS_FROM_LIVEMORE = 'Comms from LiveMore',
  COMMS_FROM_MY_NETWORK_PR = 'Comms from my network PR',
  SOURCING_SYSTEM_ADS = 'Sourcing System Ads',
  WEBINAR = 'Webinar',
  ROADSHOW_EVENT = 'F2F Roadshow / Event / Conference',
  BUSINESS_DEVELOPMENT_CALL = 'BDM Call / Visit',
  NETWORK_LAUNCH = 'Network Launch',
  OTHER = 'Other (please specify)',
}
